import styled from 'styled-components/native';

export const VerticalCenter = styled.View`
  flex: 1;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`;
